import { FC } from 'react';
import { ProfileCard } from '@/_shared/components';
import { Employer } from '@/people/state';

type Props = {
  employer: Employer;
  onEditChange?: (isEditing: boolean) => void;
};

export const EmployeeProfile: FC<Props> = ({ employer, onEditChange }) => {
  return <ProfileCard employer={employer} onEditChange={onEditChange} />;
};
